import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import MetaTags from '@/components/meta/MetaTags';
import FavoriteUsersTab from '@/components/favorites/FavoriteUsersTab';
import BulletinBackButton from '@/components/bulletins/BulletinBackButton';
import PageLayout from '@/components/layout/PageLayout';

const TopFollows: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  return (
    <PageLayout>
      <div className="min-h-screen bg-background">
        <MetaTags
          title="Top Follows – Your Favorite Creators"
          description="Manage and view your favorite creators and their latest content."
          image="/og-image.png"
          url={window.location.href}
        />

        <main className="w-full max-w-6xl mx-auto px-4 py-6">
          {/* Back Button at top of content */}
          <div className="mb-6">
            <BulletinBackButton onClose={handleBack} />
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            <FavoriteUsersTab />
          </motion.div>
        </main>
      </div>
    </PageLayout>
  );
};

export default TopFollows;